import { ReportFilterConfig } from "@aidkitorg/types/lib/admin-panel/reports";

export const hasAnyFilters = (filterConfig: ReportFilterConfig | undefined): boolean => {
  if (!filterConfig?.enabled || !filterConfig.config) return false;
    
  const checkGroup = (group: any): boolean => {
    // Check if this group has conditions
    if (group.conditions && group.conditions.length > 0) {
      return group.conditions.some((item: any) => {
        // If the item has a 'field' property, it's an actual condition
        if (item.field) {
          return true;
        }
        // If the item has 'logic' and 'conditions', it's a nested group
        if (item.logic && item.conditions) {
          return checkGroup(item);
        }
        return false;
      });
    }
    
    // Check nested groups (if any)
    if (group.groups && group.groups.length > 0) {
      return group.groups.some(checkGroup);
    }
    
    return false;
  };
    
  return checkGroup(filterConfig.config);
};